/** @format */

import { Component, input, computed, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'common-progress-spinner',
  templateUrl: './progress-spinner.component.html',
  styleUrl: './progress-spinner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressSpinnerComponent {
  diameter = input.required<number | string>();
  strokeColor = input<'white' | undefined>();
  strokeWidth = input.required<number | string>();

  diameterWithUnits = computed(() => this.toRems(this.diameter()));
  strokeWidthWithUnits = computed(() => this.toRems(this.strokeWidth()));

  private toRems(value: number | string): string {
    const floatVal = typeof value === 'number' ? value : parseFloat(value);
    return `${floatVal / 10}rem`;
  }
}
